module.exports = __webpack_public_path__ + "static/media/merchbuy-cart.6c41a937.svg";